<template>
    <div class="patsnap-biz-image_loader ai-common-image-loader">
        <div
            class="image-wrap"
            :style="cvsStyle"
        >
            <canvas
                ref="canvas"
                class="image-canvas"
            />
        </div>
    </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import ThumbModel from './ThumbModel';

export default {
    name: 'PtImageLoader',
    props: {
        /**
         * 图片数据
         */
        item: {
            type: Object,
        },
        /**
         *
         */
        // eslint-disable-next-line vue/require-prop-types
        size: {
            type: Object,
            default() {
                return {};
            },
        },
        thumbModelGenerator: {
            type: Function,
            default() {
                return ThumbModel;
            },
        },
    },
    data() {
        return {
            cvsStyle: {},
        };
    },
    async mounted() {
        const self = this;
        const model = this.thumbModelGenerator();
        await model.drawImage(self.$refs.canvas, self.item, self.item.box, self.size);
        self.cvsStyle = this.getCvsStyle();
        self.$emit('imageLoaded', self.item.id + self.item.box.join(''));
    },
    methods: {
        imageSearchClick() {
            window.open('/search/image', '_blank');
        },
        // eslint-disable-next-line consistent-return
        getCvsStyle() {
            const { box } = this.item;
            const width = this.item.oriWidth * (box[2] - box[0]);
            const height = this.item.oriHeight * (box[3] - box[1]);
            if (this.size.origin) {
                const ratio = Math.max(width / this.size.width, height / this.size.height);
                const cvsWidth = width / ratio;
                const cvsHeight = height / ratio;
                return {
                    width: `${cvsWidth}px`,
                    height: `${cvsHeight}px`,
                };
            }
        },
    },
};
</script>
